import { Create, FormDataConsumer, NullableBooleanInput, SimpleForm, TextInput } from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';
import { PdfCategoryFilterInput } from './PdfsList';

const PdfsCreate = () => {
    return (
        <Create redirect={'/pdfs'}>
            <SimpleForm>
                <FileUpload
                    type="VIDEO_THUMBNAIL"
                    required={true}
                    label="select thumbnail"
                    source="thumbnail"
                    accept="image/*"
                    multiple={false}
                />
                <TextInput source="title" fullWidth />
                <FormDataConsumer>
                    {({ formData }) => {
                        return (
                            <>
                                <FileUpload
                                    type="PDF_NOTES"
                                    required={true}
                                    source="url"
                                    label="select Pdf"
                                    accept="application/pdf"
                                    multiple={false}
                                />
                            </>
                        );
                    }}
                </FormDataConsumer>
                <NullableBooleanInput source="isDownloadable" fullWidth label={'Downloadable'} />
                <PdfCategoryFilterInput />
            </SimpleForm>
        </Create>
    );
};

export default PdfsCreate;
